import { Component, input, Input } from '@angular/core';
import { NgClass, SlicePipe } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TsBadgeModule } from '../ts-badge';

export interface TsAvatar {
  imageSrc: string;
  name: string;
}

@Component({
  selector: 'ts-avatar-group',
  standalone: true,
  imports: [NgClass, SlicePipe, MatTooltipModule, TsBadgeModule],
  templateUrl: './ts-avatar-group.component.html',
  styleUrls: ['./ts-avatar-group.component.scss'],
})
export class TsAvatarGroupComponent {
  @Input({ required: true }) avatars: TsAvatar[] = [];
  @Input() maxAvatars = 4;
  @Input() badge: string;
  @Input() size: 'normal' | 'big' = 'normal';

  roundedCorners = input<boolean>(false);

  get hasMaxNumberOfAvatars() {
    return this.avatars?.length > this.maxAvatars;
  }

  get avatarsCountAfterTheFourth() {
    if (this.hasMaxNumberOfAvatars) return this.avatars.length - this.maxAvatars;

    return 0;
  }
}
